









import { Vue, Component, Prop } from 'vue-property-decorator';
import type { IPricingTableColumn } from '@getaccept/editor-lib';
import { PricingTableHelper } from '@getaccept/editor-lib';

@Component({
  data: () => ({
    PricingTableHelper,
  }),
})
export default class PricingTableColumnHeaders extends Vue {
  @Prop() columns: IPricingTableColumn[];
  @Prop() gridTemplateColumns: string;
  @Prop() enabledColumns: IPricingTableColumn[];
}
